import * as text from 'js/constants/text';
import { LANGUAGE_CODE_ENGLISH as defaultLanguage } from 'js/constants/localization'; // TODO: this should be Spanish

import store from './store';
var language = store.getState().localization.currentLanguage;
export var localizedText = {};
Object.keys(text).map(function (key) {
  localizedText[key] = text[key][language] || text[key][defaultLanguage] || text[key][Object.keys(text[key])[0]];
});